<template>
  <div style="width: 100%">
    <el-radio-group v-model="miniType">
      <el-radio :label="1">MeCard小程序</el-radio>
      <el-radio :label="2">外部小程序</el-radio>
    </el-radio-group>
    <div v-if="miniType == 2">
      <p class="attr-item-title">小程序AppId:</p>
      <div class="col-1 attr-item-edit-input">
        <el-input placeholder="请输入小程序的AppId" v-model="form.AppId" />
      </div>
    </div>
    <p class="attr-item-title">小程序路径:</p>
    <div class="col-1 attr-item-edit-input">
      <el-input placeholder="请输入小程序路径" v-model="form.path" />
    </div>
  </div>
</template>

<script>
export default {
  name: "miniProgramForm",
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      miniType: 1,
      form: {
        path: "",
        AppId: "",
      },
    };
  },
  created() {
    console.log(value, "value");
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
    },
    miniType(newVal) {
      if (newVal == 1) {
        this.form.AppId = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-radio-group {
  width: 100%;
  text-align: left;
}
.el-radio {
  color: #fff;
}
</style>
